"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainInfoSchema = exports.SuggestingBIP44Schema = exports.Bech32ConfigSchema = exports.FeeCurrencySchema = exports.Secret20CurrencySchema = exports.CW20CurrencySchema = exports.CurrencySchema = void 0;
const feature_1 = require("./feature");
const joi_1 = __importDefault(require("joi"));
exports.CurrencySchema = joi_1.default.object({
    coinDenom: joi_1.default.string().required(),
    coinMinimalDenom: joi_1.default.string().required(),
    coinDecimals: joi_1.default.number().strict().integer().min(0).max(18).required(),
    coinGeckoId: joi_1.default.string(),
    coinImageUrl: joi_1.default.string().uri(),
});
exports.CW20CurrencySchema = exports.CurrencySchema
    .keys({
    type: joi_1.default.string().equal("cw20").required(),
    contractAddress: joi_1.default.string().required(),
})
    .custom((value) => {
    if (value.coinMinimalDenom.startsWith(`${value.type}:${value.contractAddress}:`)) {
        return value;
    }
    else {
        return Object.assign(Object.assign({}, value), { coinMinimalDenom: `${value.type}:${value.contractAddress}:` + value.coinMinimalDenom });
    }
});
exports.Secret20CurrencySchema = exports.CurrencySchema
    .keys({
    type: joi_1.default.string().equal("secret20").required(),
    contractAddress: joi_1.default.string().required(),
    viewingKey: joi_1.default.string().required(),
})
    .custom((value) => {
    if (value.coinMinimalDenom.startsWith(`${value.type}:${value.contractAddress}:`)) {
        return value;
    }
    else {
        return Object.assign(Object.assign({}, value), { coinMinimalDenom: `${value.type}:${value.contractAddress}:` + value.coinMinimalDenom });
    }
});
const GasPriceStepSchema = joi_1.default.object({
    low: joi_1.default.number().strict().required(),
    average: joi_1.default.number().strict().required(),
    high: joi_1.default.number().strict().required(),
}).custom((value) => {
    if (value.low > value.average) {
        throw new Error("Low gas price step can not be greater than average");
    }
    if (value.average > value.high) {
        throw new Error("Average gas price step can not be greater than high");
    }
    return value;
});
exports.FeeCurrencySchema = exports.CurrencySchema.keys({
    gasPriceStep: GasPriceStepSchema,
});
exports.Bech32ConfigSchema = joi_1.default.object({
    bech32PrefixAccAddr: joi_1.default.string().required(),
    bech32PrefixAccPub: joi_1.default.string().required(),
    bech32PrefixValAddr: joi_1.default.string().required(),
    bech32PrefixValPub: joi_1.default.string().required(),
    bech32PrefixConsAddr: joi_1.default.string().required(),
    bech32PrefixConsPub: joi_1.default.string().required(),
});
exports.SuggestingBIP44Schema = joi_1.default.object({
    coinType: joi_1.default.number().strict().integer().min(0).required(),
}).unknown(true);
exports.ChainInfoSchema = joi_1.default.object({
    rpc: joi_1.default.string()
        .uri()
        .custom((value) => {
        if (value.includes("?")) {
            throw new Error("rpc should not have query string");
        }
        return value;
    })
        .required(),
    rest: joi_1.default.string()
        .uri()
        .custom((value) => {
        if (value.includes("?")) {
            throw new Error("rest should not have query string");
        }
        return value;
    })
        .required(),
    nodeProvider: joi_1.default.object({
        name: joi_1.default.string().min(1).max(30).required(),
        email: joi_1.default.string()
            .email({
            tlds: {
                allow: false,
            },
        })
            .required(),
        website: joi_1.default.string().uri(),
    }),
    chainId: joi_1.default.string().required().min(1).max(30),
    chainName: joi_1.default.string().required().min(1).max(30),
    stakeCurrency: exports.CurrencySchema.required(),
    walletUrl: joi_1.default.string().uri(),
    walletUrlForStaking: joi_1.default.string().uri(),
    bip44: exports.SuggestingBIP44Schema.required(),
    alternativeBIP44s: joi_1.default.array()
        .items(exports.SuggestingBIP44Schema)
        .custom((values) => {
        const dups = {};
        for (const val of values) {
            if (dups[val.coinType]) {
                throw new Error(`coin type ${val.coinType} is duplicated`);
            }
            dups[val.coinType] = true;
        }
        return values;
    }),
    bech32Config: exports.Bech32ConfigSchema.required(),
    currencies: joi_1.default.array()
        .min(1)
        .items(exports.CurrencySchema, exports.CW20CurrencySchema, exports.Secret20CurrencySchema)
        .custom((values) => {
        const dups = {};
        for (const val of values) {
            if (dups[val.coinMinimalDenom]) {
                throw new Error(`${val.coinMinimalDenom} is duplicated`);
            }
            dups[val.coinMinimalDenom] = true;
        }
        return values;
    })
        .required(),
    feeCurrencies: joi_1.default.array()
        .min(1)
        .items(exports.FeeCurrencySchema)
        .custom((values) => {
        const dups = {};
        for (const val of values) {
            if (dups[val.coinMinimalDenom]) {
                throw new Error(`${val.coinMinimalDenom} is duplicated`);
            }
            dups[val.coinMinimalDenom] = true;
        }
        return values;
    })
        .required(),
    coinType: joi_1.default.number().strict().integer(),
    beta: joi_1.default.boolean(),
    features: joi_1.default.array()
        .items(joi_1.default.string().valid(...feature_1.SupportedChainFeatures))
        .unique()
        .custom((value) => {
        if (value.indexOf("cosmwasm") >= 0 && value.indexOf("secretwasm") >= 0) {
            throw new Error("cosmwasm and secretwasm are not compatible");
        }
        return value;
    }),
    chainSymbolImageUrl: joi_1.default.string().uri(),
}).custom((value) => {
    var _a;
    if ((_a = value.alternativeBIP44s) === null || _a === void 0 ? void 0 : _a.find((bip44) => bip44.coinType === value.bip44.coinType)) {
        throw new Error(`coin type ${value.bip44.coinType} is duplicated`);
    }
    return value;
});
//# sourceMappingURL=schema.js.map